import { Modal } from "antd";
import { Box, CircularProgress } from "@mui/material";

/**
 * Dialogo Sim/Nao generico. Substitui os ~7 <Modal okText="Sim" cancelText="Nao">
 * quase identicos que existiam no componente (cancelar, suspender, restaurar,
 * iniciar negociacao, desnegociar, avancar, retroceder).
 */
export function ConfirmacaoModal({ open, title = "Confirmação", mensagem, onConfirm, onCancel, loading = false }) {
  return (
    <Modal open={open} title={title} okText="Sim" cancelText="Não" onOk={onConfirm} onCancel={onCancel}>
      {mensagem}
      {loading && (
        <div className="margin-0-auto">
          <Box sx={{ display: "flex" }}>
            <CircularProgress />
          </Box>
        </div>
      )}
    </Modal>
  );
}

export default ConfirmacaoModal;
